export namespace EnumTypes {
    export enum Status {
        NEW = 'NEW',
        INSTALLATION_DATE_CONFIRMED = 'INSTALLATION_DATE_CONFIRMED',
        INSTALLATION_FINISHED = 'INSTALLATION_FINISHED',
        INSTALLATION_CONFIRMED = 'INSTALLATION_CONFIRMED',
        CANCELLED = 'CANCELLED',
    }

    export enum HistoryEventType {
        STATUS_CHANGED = 'STATUS_CHANGED',
        DATA_CHANGED = 'DATA_CHANGED'
    }

    export enum HistoryRequestStatus {
        SHOW = 'SHOW',
        HIDDEN = 'HIDDEN'
    }

    export enum CountryCode {
        UNDEFINED, AC, AD, AE, AF, AG, AI, AL, AM, AN, AO, AQ, AR, AS, AT, AU, AW, AX, AZ, BA, BB, BD, BE, BF, BG, BH, BI, BJ, BL, BM, BN, BO, BQ, BR, BS, BT, BU, BV, BW, BY, BZ, CA, CC, CD, CF, CG, CH, CI, CK, CL, CM, CN, CO, CP, CR, CS, CU, CV, CW, CX, CY, CZ, DE, DG, DJ, DK, DM, DO, DZ, EA, EC, EE, EG, EH, ER, ES, ET, EU, EZ, FI, FJ, FK, FM, FO, FR, FX, GA, GB, GD, GE, GF, GG, GH, GI, GL, GM, GN, GP, GQ, GR, GS, GT, GU, GW, GY, HK, HM, HN, HR, HT, HU, IC, ID, IE, IL, IM, IN, IO, IQ, IR, IS, IT, JE, JM, JO, JP, KE, KG, KH, KI, KM, KN, KP, KR, KW, KY, KZ, LA, LB, LC, LI, LK, LR, LS, LT, LU, LV, LY, MA, MC, MD, ME, MF, MG, MH, MK, ML, MM, MN, MO, MP, MQ, MR, MS, MT, MU, MV, MW, MX, MY, MZ, NA, NC, NE, NF, NG, NI, NL, NO, NP, NR, NT, NU, NZ, OM, PA, PE, PF, PG, PH, PK, PL, PM, PN, PR, PS, PT, PW, PY, QA, RE, RO, RS, RU, RW, SA, SB, SC, SD, SE, SF, SG, SH, SI, SJ, SK, SL, SM, SN, SO, SR, SS, ST, SU, SV, SX, SY, SZ, TA, TC, TD, TF, TG, TH, TJ, TK, TL, TM, TN, TO, TP, TR, TT, TV, TW, TZ, UA, UG, UK, UM, US, UY, UZ, VA, VC, VE, VG, VI, VN, VU, WF, WS, XK, YE, YT, YU, ZA, ZM, ZR, ZW
    }

    export enum CarPictureType {
        VIN = "VIN",
        CAR_FRONT = "CAR_FRONT",
        CAR_BACK = "CAR_BACK",
        DASHBOARD = "DASHBOARD"
    }
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/TerminalInstallationEnumTypes.ts